import { Trans, useTranslation } from "react-i18next";
import {
  Button,
  Box,
  Container,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import { Note } from "@appsflyer/fe-ui-core";
import { IProgress, ISessionProps, OSType } from "../main/components/IProgress";
import { useLocation, useNavigate } from "react-router-dom";
import transition from "../main/components/transition";
import { useState, useEffect } from "react";
import AmplitudeLink from "../services/AmplitudeLink";
import { amplitudeTrack_continue } from "../services/utils";

const AdRevenueTestAutomated = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [osType] = useState<OSType>(location.state?.os);
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {}, []);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleClick = () => {
    const progressArr: IProgress[] = location.state?.progress.slice();
    progressArr.push({
      id: "startsdk_testevents_manual",
      text: "progress_startsdk_testevents",
      order: 7,
    });

    const progressState: ISessionProps = {
      ...location.state,
      progress: progressArr,
      currentPage: location.state?.currentPage + 1,
    };

    amplitudeTrack_continue(location.state);
    console.log(progressState);
    navigate(`/adrevenue/${osType.toLowerCase()}/eventstestconsole`, {
      state: progressState,
    });
  };

  const steps = [
    {
      label: t("startSDK_TestSDKIntegration_android_Step1"),
      component: (
        <>
          <Typography variant="body1">
            {t("ip_TestInAppIntegration_ios_stepOneContent")}
            <br />
            {t("ip_TestInAppIntegration_ios_stepOneContent_b")}
            <Trans i18nKey="adRevenue_event_snippet_title" />
            {t("ip_TestInAppIntegration_ios_stepOneContent_d")}
          </Typography>
        </>
      ),
      shouldDisplayNavigationButtons: true,
    },
    {
      label: t("adRevenue_test_trigger_step_title"),
      component: (
        <>
          <Typography>
            <Trans i18nKey={"adRevenue_test_trigger_step_desc"}/>
          </Typography>
          {location.state?.os === OSType.iOS &&
            location.state?.deviceType === "IDFA" && (
              <Box mt={2}>
                <Note>
                  <Typography style={{ display: "inline" }}>
                    {t("testConsole_TestType_myDeviceID_iosAtt")}
                  </Typography>
                </Note>
              </Box>
            )}
        </>
      ),
      shouldDisplayNavigationButtons: true,
    },
  ];

  if (location.state.os === OSType.iOS) {
    steps.push({
      label: t("testConsole_TestType_myDeviceID_iosAtt"),
      component: (
        <>
          <img
            style={{ maxWidth: 300 }}
            src={process.env.PUBLIC_URL + "/images/ATT_screen.png"}
            alt="Debug Logs"
          />
        </>
      ),
      shouldDisplayNavigationButtons: true,
    });
  }

  return (
    <Container maxWidth={"lg"}>
      <Box padding={3} style={{ minHeight: "50vh" }}>
        <Typography variant="h1" sx={{ mb: 2 }}>
          {t("adRevenue_Test_Ad_Revenue_Integration")}
        </Typography>
        <Note title={""} sx={{ mt: 2 }}>
          <Typography>
          <Trans
              i18nKey="adRevenue_beforeYouStart_1"
              components={{
                strong: <strong />,
                em: <em />,
              }}
            />
            <AmplitudeLink
              href="https://hq1.appsflyer.com/revenue-config/overview"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("adRevenue_beforeYouStart_Link_1")}
            </AmplitudeLink>
            <Trans
              i18nKey="adRevenue_beforeYouStart_2"
              components={{
                strong: <strong />,
                em: <em />,
              }}
            />
            <AmplitudeLink
              href="https://support.appsflyer.com/hc/en-us/articles/217490046-ROI360-guide-ad-revenue-attribution#connect-to-ad-revenue-integrated-partners"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("adRevenue_beforeYouStart_Link_2")}
            </AmplitudeLink>
            .
          </Typography>
        </Note>
        <Stepper
          activeStep={activeStep}
          style={{ border: "none" }}
          orientation="vertical"
        >
          {steps.map(({ label, component, shouldDisplayNavigationButtons }) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
              <StepContent>
                {component}
                {shouldDisplayNavigationButtons && (
                  <Box sx={{ mt: 2 }}>
                    {activeStep !== 0 && (
                      <Button
                        variant="text"
                        color="primary"
                        onClick={handleBack}
                        // sx={{ mt: 2, mr: 1 }}
                      >
                        {t("general_Back")}
                      </Button>
                    )}
                    {activeStep !== steps.length - 1 && (
                      <Button
                        // sx={{ mt: 2 }}
                        variant="contained"
                        color="primary"
                        onClick={handleNext}
                      >
                        {activeStep === steps.length - 1
                          ? t("general_Finish")
                          : t("general_Next")}
                      </Button>
                    )}
                  </Box>
                )}
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </Box>
      <Box
        display={"flex"}
        width={"100%"}
        justifyContent="space-between"
        alignSelf="end"
        justifySelf="end"
        marginTop={10}
        textAlign="end"
      >
        {" "}
        <Button
          variant="outlined"
          size="medium"
          color="secondary"
          style={{ marginRight: "5px" }}
          onClick={() => navigate(-1)}
        >
          {t("general_Back")}
        </Button>
        <Button
          variant="contained"
          size="medium"
          color="primary"
          onClick={() => handleClick()}
          disabled={activeStep != steps.length - 1}
        >
          {t("testconsole_getRes")}
        </Button>
      </Box>
    </Container>
  );
};

export default transition(AdRevenueTestAutomated);
